import React from 'react';
import { withRouter } from 'react-router-dom';
import { Card, Row, Col } from 'react-bootstrap';
import AdminKeypad from '../components/AdminKeypad';
import { SettingContext } from '../context/SettingContext';
import { UserConsumer } from '../context/ThemeContext';
import { Redirect } from 'react-router-dom';
import { adminAction } from '../services/adminService';
import APIProgress from './APIProgress';
import TransactionConfirmModal from './TransactionConfirmModal';
import ErrorModal from './ErrorModal';
import TerminalInfoModal from './TerminalInfoModal';

class Admin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTerminal: props.history.location.state ? props.history.location.state.selectedTerminal : '',
            apiProgress: false,
            apiResult: '',
            errorDesc: '',
            showModal: false,
            showError: false,
            showTerminalInfoModal: false,
            apiProgressText: '',
            operatorId: localStorage.operatorId ? localStorage.operatorId.length < 4 ? '0000' : localStorage.operatorId : '0000'
        };
    }

    closeModal = () => {
        this.setState({
            showModal: false,
            showTerminalInfoModal: false,
            apiResult: ''
        });
    }

    closeError = () => {
        this.setState({
            showError: false
        }, this.state.errorDesc === 'Timeout' ? window.location.reload(false) : null);
    }

    showProgressModal = (apiResult) => {
        this.setState({
            apiProgress: false,
            apiResult: apiResult,
            showModal: true
        });
    }

    showErrorModal = (errorDesc) => {
        this.setState({
            apiProgress: false,
            errorDesc: errorDesc,
            showError: true
        });
    }

    getTerminalInfo = () => {
        // console.log("Getting Terminal Info")
        this.setState({
            showTerminalInfoModal: true
        });
    }

    onClick = (button, ErrorText) => {
        this.setState({
            apiProgress: true,
            apiProgressText: button,
        });
        adminAction(button, this.state.selectedTerminal, this.state.operatorId).then(response => {
            if (response.status === 200) {
                if (button === 'reconciliation') {
                    this.showProgressModal(response.data.result.reconciliation.printText.Text);
                }
                else {
                    if (response.data.result.printText) {
                        this.showProgressModal(response.data.result.printText.Text);
                    } else {
                        if (!Object.keys(response.data.result).length) {
                            this.showProgressModal(ErrorText.TerminalConnection);
                        } else {
                            // if (response.data.result.localModeEventArgs.RejectionReason === null) {
                            //     this.showErrorModal("SomethingWrong")
                            // } else {
                            //     this.showProgressModal(response.data.result)
                            // }

                            this.showErrorModal(response.data.result.localModeEventArgs.RejectionReason ? response.data.result.localModeEventArgs.RejectionReason : 'SomethingWrong');
                        }

                    }

                }
            }
            else {

                if (response.message === 'Network Error') {
                    this.showErrorModal('SomethingWrong');
                } else if (response.response.status === 401 || response.response.status === 504) {
                    this.showErrorModal('Timeout');
                } else if (response.response.status === 400) {
                    this.showErrorModal('TerminalConnection');
                }
                else {
                    !Object.keys(response.response.data.failure.error).length ?
                        this.showErrorModal('TerminalConnection')
                        :
                        this.showErrorModal('SomethingWrong');
                }

            }
        });
    }

    render() {
        if (this.state.selectedTerminal === '') {
            return <Redirect to="/" />;
        }
        return (
            <SettingContext.Consumer>{(settingContext) => (
                <UserConsumer>
                    {themeProp => {
                        const { translatedContent } = settingContext;
                        return (
                            <>
                                {this.state.showModal ?
                                    <TransactionConfirmModal show={this.state.showModal} buttonText={translatedContent.DialogueBox} result={this.state.apiResult} closeModal={this.closeModal} />
                                    : null}
                                {this.state.showError ?
                                    <ErrorModal show={this.state.showError} translate={translatedContent.ErrorCode} errorDesc={this.state.errorDesc} closeError={this.closeError} isMobile={themeProp.dimensions.isMobile} />
                                    : null}
                                {this.state.apiProgress ?
                                    <APIProgress progressText={translatedContent.ProgressText[this.state.apiProgressText]} terminalID={this.state.selectedTerminal} show={this.state.apiProgress} />
                                    : null}
                                {this.state.showTerminalInfoModal ?
                                    <TerminalInfoModal show={this.state.showTerminalInfoModal} translatedContent={translatedContent.TerminalDetail} showErrorModal={this.showErrorModal} buttonText={translatedContent.DialogueBox} closeModal={this.closeModal} />
                                    : null}
                                <Row className="mt-4">
                                    <Col md={{ span: 4, offset: 4 }} >
                                        <Card className="text-center">
                                            <Card.Body>
                                                <Card.Title>{translatedContent.AdministrationFor + ' \'' + this.state.selectedTerminal + '\' '} </Card.Title>
                                                <Card.Subtitle className="mb-2 text-muted">
                                                    Operator ID: {this.state.operatorId}
                                                </Card.Subtitle>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col md={{ span: 8, offset: 2 }} >
                                        <AdminKeypad onClick={this.onClick} operatorId={this.state.operatorId} getTerminalInfo={this.getTerminalInfo} AdminKey={translatedContent.AdminKey} isMobile={themeProp.dimensions.isMobile} />
                                    </Col>
                                </Row>
                            </>
                        );
                    }}
                </UserConsumer>
            )}</SettingContext.Consumer>);
    }
}

export default withRouter(Admin);